// import React, { useEffect, useState } from 'react';
// import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
// import axios from 'axios';
// import { generateHeaders, getBaseUrl } from '../../utils/helpers.js';



// const PayPalPayment = ({ amount, onSuccess, onError }) => {
//     const [paid, setPaid] = useState(false);

//     const clientId = process.env.PAYPAL_CLIENT_ID
//     const baseUrl = getBaseUrl()
//     const headers = generateHeaders()

//     // useEffect(() => {
//     //     fetch(`${baseUrl}/api/providers/paypal/credentials`, { headers: headers })
//     //         .then(res => {
//     //             if (res.ok) {
//     //                 return res.json()
//     //             }
//     //         }).then(data => {
//     //             setCredentials(data)
//     //         })
//     // }, [])

//     const createOrder = async () => {
//         try {
//             const response = await axios.post(`${baseUrl}/api/payments/paypal/createOrder`, {
//                 amount: amount
//             });
//             return response.data.id;
//         } catch (err) {
//             onError(err.response?.data?.error || 'Failed to create order');
//             throw err;
//         }
//     };

//     const onApprove = async (data) => {
//         try {
//             const response = await axios.post(`${baseUrl}/api/payments/paypal/captureOrder`, {
//                 order_id: data.orderID
//             });

//             setPaid(true);
//             onSuccess(response.data);
//         } catch (err) {
//             onError(err.response?.data?.error || 'Payment failed');
//         }
//     };


//     return (
//         <PayPalScriptProvider
//             options={{
//                 "client-id": clientId,
//                 currency: "USD"
//             }}
//         >
//             {!paid ? (
//                 <PayPalButtons

//                     createOrder={createOrder}
//                     onApprove={onApprove}
//                     onError={onError}
//                 />
//             ) : (
//                 <div>Payment successful!</div>
//             )}
//         </PayPalScriptProvider>
//     );
// };

// export default PayPalPayment;


import React, { useState } from 'react';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from 'axios';
import { generateHeaders, getBaseUrl } from '../../utils/helpers.js';

const PayPalPayment = ({ amount, onSuccess, onError }) => {
  const [paid, setPaid] = useState(false);

  // 👉 Se estiveres usando CRA:
  const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;

  // console.log("PayPal Client ID:", clientId);

  // 👉 Se estiveres usando Vite, troca por:
  // const clientId = import.meta.env.VITE_PAYPAL_CLIENT_ID;

  const baseUrl = getBaseUrl();
  const headers = generateHeaders();

  const createOrder = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/payments/paypal/createOrder`,
        { amount },
        { headers }
      );
      return response.data.id;
    } catch (err) {
      onError(err.response?.data?.error || 'Failed to create order');
      throw err;
    }
  };

  const onApprove = async (data) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/payments/paypal/captureOrder`,
        { order_id: data.orderID },
        { headers }
      );
      console.log("aaaa", response)
      setPaid(true);
      onSuccess(response.data);
    } catch (err) {
      onError(err.response?.data?.error || 'Payment failed');
    }
  };



  return (
    <PayPalScriptProvider
      options={{
        "client-id": clientId,
        currency: "USD",
      }}
    >
      {!paid ? (
        <PayPalButtons
          createOrder={createOrder}
          onApprove={onApprove}
          onError={onError}
        />
      ) : (
        <div style={{ textAlign: 'center', color: 'green', marginTop: '20px' }}>
          Payment successful!
        </div>
      )}
    </PayPalScriptProvider>
  );
};

export default PayPalPayment;
